export const productTransformer = ({ product, selectedUpcId, hasPurchasedItems, isRegistrant, productCardImage, isRegistryPostCompletion }) => {
  if (isRegistryPostCompletion || (product && !product?.relationships?.upcs?.[selectedUpcId?.toString()])) {
    product.traits = {
      colors: {},
      traitsMaps: { upcMap: {} },
    };
    product.relationships = {};
    const images = [
      {
        filePath: productCardImage?.primaryImage?.filePath,
      },
    ];
    if (!product?.imagery) {
      product.imagery = { images };
    } else if (!(product?.imagery?.images?.length > 0)) {
      product.imagery.images = images;
    } else if (!product?.imagery?.images?.[0]?.filePath) {
      product.imagery.images[0].filePath = productCardImage?.primaryImage?.filePath;
    }
    return product;
  }
  if (product?.traits?.traitsMaps?.upcMap) {
    const oldUpcMap = product.traits.traitsMaps.upcMap;
    const newUpcMap = {};
    Object.keys(oldUpcMap).forEach((key) => {
      const parts = key.split('_');
      if (parts.length === 3) {
        const newKey = `${parts[0]}_${parts[1]}`;
        newUpcMap[newKey] = oldUpcMap[key];
      } else {
        newUpcMap[key] = oldUpcMap[key];
      }
    });
    product.traits.traitsMaps.upcMap = newUpcMap;
  }
  if (product?.traits && product?.traits?.colors && Object.prototype.toString.call(product?.traits?.colors?.colorMap) === '[object Object]') {
    product.imagery.additionalImageSource = product?.imagery?.images; // updates images name to additionalImageSource
    delete product?.imagery?.images;
    // convert an object to an array
    const colorMapArray = Object.values(product?.traits?.colors?.colorMap);
    // filter the selected color with id
    const selectedColorId = Object.keys(product?.traits?.traitsMaps?.upcMap).find((id) => product.traits.traitsMaps.upcMap[id] === selectedUpcId);
    const colorFromRelationshipUPC = product?.relationships?.upcs?.[selectedUpcId]?.traits?.colors?.selectedColor;
    let colorId;
    if (selectedColorId) {
      colorId = selectedColorId;
      colorId = colorId.split('_')[0];
    } else if (colorFromRelationshipUPC) {
      colorId = colorFromRelationshipUPC;
    } else {
      return null;
    }
    const selectedColor = colorMapArray.filter((color) => color.id === Number(colorId))[0];
    Object.assign(selectedColor, { upcKey: selectedColorId });
    const colorMap = colorMapArray.map((color) => {
      color.imagery.additionalImageSource = color.imagery.images;
      delete color.imagery.images;
      return color;
    });
    product.traits.colors.colorMap = colorMap;
    product.traits.colors.selectedColor = selectedColor;
    if (hasPurchasedItems || !isRegistrant) {
      // updating color and size object when item has purchased items
      delete product.traits.sizes;
      product.traits.colors.colorMap = [colorMap.find((color) => color.id === selectedColor.id)];
    }
    const colorsList = product?.traits?.colors?.colorMap?.map((color) => color.id);
    if (product?.traits?.sizes?.sizeMap) {
      const selectedSize = selectedColorId?.split('_')[1] || '';
      if (!Object.prototype.hasOwnProperty.call(product.traits.sizes, selectedSize && selectedSize !== '')) {
        product.traits.sizes.selectedSize = Number(selectedSize);
      }
      Object.values(product.traits.sizes.sizeMap).map((size, sizeIndex) => {
        if (!Object.prototype.hasOwnProperty.call(size, 'colors')) {
          const availableColorsArray = Object.values(size.typeToColors);
          const availableColors = availableColorsArray.map((firstLevel) => firstLevel.map((secondLevel) => secondLevel)).flat();
          const availableColorsForSize = colorsList.filter((color) => availableColors.includes(color));
          product.traits.sizes.sizeMap[sizeIndex].colors = availableColorsForSize;
        }
        return size;
      });
    }
    return product;
  }
  return product;
};

export default {
  productTransformer,
};
